/* kesho : T47, les liens du sous-menu commencent sous l'élément du menu survolé ou focalisé (ordi seulement).
   Pose --kesho-submenu-offset sur le panneau ; header-menu.js n'est pas touché. Sans ce script, le menu fonctionne comme avant. */
(() => {
  const desktop = window.matchMedia('(min-width: 750px)');
  const MIN_COLUMN = 200;

  function place(event) {
    if (!desktop.matches || !(event.target instanceof Element)) return;

    const item = event.target.closest('.menu-list__list-item:not([slot])');
    // kesho : T53, on aligne sur le texte du lien (son titre), pas sur la boîte du lien dont le titre a un retrait de 11,2 px (compté plus bas)
    const link = item && item.querySelector(':scope > .menu-list__trigger > .menu-list__link .menu-list__link-title, :scope > .menu-list__link .menu-list__link-title');
    const panel = item && item.querySelector(':scope > .menu-list__submenu');
    if (!link || !panel) return;

    // Position de départ des liens sans décalage, puis décalage pour qu'ils commencent sous l'élément survolé.
    panel.style.setProperty('--kesho-submenu-offset', '0px');
    const links = panel.querySelectorAll('.mega-menu__link');
    const first = links[0];
    if (!first) return;

    const base = first.getBoundingClientRect().left;
    let column = MIN_COLUMN;
    links.forEach((el) => {
      column = Math.max(column, el.getBoundingClientRect().width);
    });

    // le titre a un retrait intérieur (padding-inline) : le texte commence après lui
    const textLeft = link.getBoundingClientRect().left + (parseFloat(getComputedStyle(link).paddingLeft) || 0);
    const wanted = textLeft - base;
    const room = document.documentElement.clientWidth - base - column - 16;
    const offset = Math.max(0, Math.min(wanted, room));
    panel.style.setProperty('--kesho-submenu-offset', `${Math.round(offset)}px`);
  }

  document.addEventListener('pointerover', place, { passive: true });
  document.addEventListener('focusin', place, { passive: true });
})();
